import { startFunnelSession, recordFunnelStep, endFunnelSession, getFunnelSessionState } from "@/utils/behaviorTracker";
import { safeTrack } from "./track";
import { PAGE_KEYS } from "./pageKeys";

function normalizeCfdSymbol(raw) {
  const symbol = String(raw || "")
    .replace(/_/g, "")
    .trim()
    .toUpperCase();
  return symbol || undefined;
}

/** PRD feature_use：区分 CFD 页 Fiat-M / USDT-M / Spot */
export const CFD_MARKET_TYPES = {
  FIAT_M: "fiat_m",
  USDT_M: "usdt_m",
  SPOT: "spot",
};

export function tabTypeToMarketType(tab) {
  if (tab === "fiatContract") return CFD_MARKET_TYPES.FIAT_M;
  if (tab === "uContract") return CFD_MARKET_TYPES.USDT_M;
  if (tab === "spot") return CFD_MARKET_TYPES.SPOT;
  return undefined;
}

export function trackCfdMarketTabSelect({
  marketType,
  pagePath,
  pageKey = PAGE_KEYS.CFD_TRADE,
}) {
  if (!marketType) return null;
  return safeTrack("feature_use", {
    page: pagePath || "",
    properties: {
      feature: "cfd_trade",
      action: "market_tab_select",
      page_key: pageKey,
      market_type: marketType,
    },
  });
}

export function trackCfdEntryClick({ entry, pagePath, pageKey = PAGE_KEYS.CFD_TRADE }) {
  startFunnelSession("cfd");
  recordFunnelStep(1);
  return safeTrack("cfd_entry_click", {
    page: pagePath || "",
    properties: { entry, page_key: pageKey },
  });
}

export function trackCfdPageView({ symbol, pagePath, pageKey = PAGE_KEYS.CFD_TRADE }) {
  const normalizedSymbol = normalizeCfdSymbol(symbol);
  if (!normalizedSymbol) return null;
  if (!getFunnelSessionState()) {
    startFunnelSession("cfd", { symbol: normalizedSymbol });
  }
  recordFunnelStep(2, { symbol: normalizedSymbol });
  return safeTrack("cfd_page_view", {
    page: pagePath || "",
    properties: { page_key: pageKey, symbol: normalizedSymbol },
  });
}

export function trackCfdSideSelect({ symbol, side, pagePath, pageKey = PAGE_KEYS.CFD_TRADE }) {
  const normalizedSymbol = normalizeCfdSymbol(symbol);
  if (!normalizedSymbol) return null;
  recordFunnelStep(3, { symbol: normalizedSymbol });
  return safeTrack("cfd_side_select", {
    page: pagePath || "",
    properties: { page_key: pageKey, symbol: normalizedSymbol, side },
  });
}

export function trackCfdOrderConfirm({
  symbol,
  orderType,
  leverage,
  margin,
  pagePath,
  pageKey = PAGE_KEYS.CFD_TRADE,
}) {
  const normalizedSymbol = normalizeCfdSymbol(symbol);
  if (!normalizedSymbol) return null;
  recordFunnelStep(4, { symbol: normalizedSymbol });
  return safeTrack("cfd_order_confirm", {
    page: pagePath || "",
    properties: {
      page_key: pageKey,
      symbol: normalizedSymbol,
      order_type: orderType,
      leverage: String(leverage || ""),
      margin: String(margin || ""),
    },
  });
}

export function trackCfdOrderFail({ symbol, errorCode, pagePath, pageKey = PAGE_KEYS.CFD_TRADE }) {
  const normalizedSymbol = normalizeCfdSymbol(symbol);
  if (!normalizedSymbol) return null;
  return safeTrack("cfd_order_fail", {
    page: pagePath || "",
    properties: {
      page_key: pageKey,
      symbol: normalizedSymbol,
      error_code: String(errorCode || "UNKNOWN"),
    },
  });
}

export function trackCfdAbandon({ symbol, lastStep, pagePath, pageKey = PAGE_KEYS.CFD_TRADE }) {
  const normalizedSymbol = normalizeCfdSymbol(symbol);
  if (!normalizedSymbol) return null;
  const state = getFunnelSessionState();
  safeTrack("cfd_abandon", {
    page: pagePath || "",
    properties: {
      page_key: pageKey,
      symbol: normalizedSymbol,
      last_step: Number(lastStep != null ? lastStep : state?.lastStep || 1),
    },
  });
  endFunnelSession();
}
